import * as React from 'react'
import Header from '../components/Header'
import { Provider } from 'rebass'
import styled, { injectGlobal } from 'styled-components'
import Logo from '../components/Logo'

// http://www.heropatterns.com/
const BACKGROUND_PATTERN = `data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%239C92AC' fill-opacity='0.04'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E`

injectGlobal`
  body {
    margin: 0;
  }
`

const SiteWrapper = styled.div`
  * {
    box-sizing: border-box;
  }
  background: white;
  background-image: url("${BACKGROUND_PATTERN}");
  padding: 1rem;
  min-height: 100vh;
  display: flex;
  flex-flow: row nowrap;
  body {
    margin: 0 !important;
    padding: 0;
  }
  p > a {
    font-weight: bold;
  }
  display: grid;
  grid-template-columns: 1fr 5fr;
  grid-template-rows: 100px calc(100vh - 100px - 2rem) auto;
grid-template-areas:  "logo-content main-content" "sider-content main-content" ". main-content";
@media (max-width: 700px) {
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  grid-template-areas:  "logo-content" "main-content" "sider-content"; 
}

`

const Main = styled.main`
  flex: 1;
  padding: 1rem;
  padding-bottom: 2rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  grid-area: main-content;
  overflow: auto;
`

const SiderContent = styled.div`
  grid-area: sider-content;
`
const LogoContent = styled.div`
  grid-area: logo-content;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
`

class Template extends React.PureComponent<{
  children: () => React.ReactNode
}> {
  render() {
    const blogPosts = this.props.data.allMarkdownRemark.edges.map(n => n.node)
    return (
      <Provider theme={{}}>
        <SiteWrapper>
          <LogoContent>
            <Logo />
          </LogoContent>
          <SiderContent>
            <Header blogPosts={blogPosts} />
          </SiderContent>
          <Main>{this.props.children()}</Main>
        </SiteWrapper>
      </Provider>
    )
  }
}

export default Template

export const pageQuery = graphql`
  query LayoutQuery {
    allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      limit: 3
    ) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "DD MMMM, YYYY")
            title
            summary
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.tsx